module.exports = __webpack_public_path__ + "static/media/005.6fbeeb67.jpg";